// src/components/CardUmatActions.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PERMISSIONS, { hasUmatPermission, apiFetch } from "../utils/wkCommon";
import { hasUmatPermissionAsync } from "../utils/permissionsAsync";
import { getUser } from "../utils/auth";
import { isZh } from "../utils/language";
import { checkHasPin, resetPinByEmail } from "../utils/PINService";
import { clearPinConfirmed } from "../utils/PINSession";
import QrPusat from "../components/QrPusat";

const css = `
.card-umat-actions{display:flex;gap:0.5rem;flex-wrap:wrap;margin-top:1rem}
.cu-btn{cursor:pointer;font-weight:700;padding:0.45rem 0.75rem;border-radius:0.5rem;text-decoration:none;font-size:0.9rem}
.cu-primary{background:#0b63a8;color:#fff}
.cu-disabled{opacity:0.5;pointer-events:none;cursor:not-allowed;}
`;

export default function CardUmatActions({ umat }) {
  const user = getUser();
  const email = user?.email ?? null;
  const documentId = umat?.documentId ?? umat?.raw?.documentId ?? null;
  const tsfyUmatID = umat?.tsfyUmatID ?? umat?.raw?.tsfyUmatID ?? null;

  const [canFull, setCanFull] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canResetPin, setCanResetPin] = useState(false);

  const [isResetting, setIsResetting] = useState(false);
  const [hasPinValue, setHasPinValue] = useState(false);

  const [canBasic, setCanBasic] = useState(false);
  const [showQrPusat, setShowQrPusat] = useState(false);


  async function handleResetPin() {
    const targetEmail = umat?.LoginEmail || umat?.email;
    if (!targetEmail) return;

    const confirmMsg = isZh()
      ? "確定要重設此用戶的 PIN 嗎？"
      : "Apakah Anda yakin ingin reset PIN user ini?";

    if (!window.confirm(confirmMsg)) return;

    setIsResetting(true);

    try {
      const res = await resetPinByEmail(targetEmail);

      if (!res.ok) throw new Error(res.message);

      window.appToast?.(
        isZh() ? "PIN 已重設成功" : "PIN berhasil direset",
        { type: "success" }
      );

      setHasPinValue(false);

    } catch (err) {
      window.appToast?.(
        err.message || (isZh() ? "重設 PIN 失敗" : "Gagal reset PIN"),
        { type: "error" }
      );
    } finally {
      setIsResetting(false);
    }
  }

  useEffect(() => {
    let mounted = true;
    async function load() {
      const ok = await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_FULL);
      if (mounted) setCanFull(Boolean(ok));

      const b = await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_BASIC);
      if (mounted) setCanBasic(Boolean(b));

      const a = await hasUmatPermissionAsync(email, PERMISSIONS.UMATDATA_EDIT);
      if (mounted) setCanEdit(Boolean(a));

      const r = await hasUmatPermissionAsync(email, PERMISSIONS.CONFIGROLEPERMISSION_EDIT);
      if (mounted) setCanResetPin(Boolean(r));

      if (documentId) {
        const okPin = await checkHasPin(umat?.LoginEmail || umat?.email);
        if (mounted) setHasPinValue(Boolean(okPin));
      }      
    }
    load();
    return () => { mounted = false };
  }, [email]);

  //console.log("cardumatactions", umat)
  return (
    <>
    <div className="card-umat-actions">
      <style dangerouslySetInnerHTML={{ __html: css }} />
      {canFull && documentId && (
        <Link
          to={`/profile/${encodeURIComponent(documentId)}`}
          className="cu-btn cu-primary"
        >
          {isZh() ? "詳細資料" : "Profil Lengkap"}
        </Link>
      )}

      {canFull && documentId && (
        <>
          <Link
            to={`/UmatDataUpdate?tab=individual&umat=${encodeURIComponent(documentId)}`}
            className="cu-btn cu-primary"
          >
            {isZh() ? "修改資料" : "Update Data"}
          </Link>

          <Link
            to={`/UmatDataUpdate?tab=mapping&umat=${encodeURIComponent(documentId)}`}
            className="cu-btn cu-primary"
          >
            {isZh() ? "求道資料對應" : "Mapping Data QiuDao"}
          </Link>
        </>
      )}

      {canResetPin && documentId && (
        <button
          onClick={handleResetPin}
          disabled={!hasPinValue || isResetting}
          className={`cu-btn cu-primary ${(!hasPinValue || isResetting) ? "cu-disabled" : ""}`}
        >
          {isResetting
            ? (isZh() ? "處理中..." : "Memproses...")
            : (isZh() ? "重設 PIN" : "Reset PIN")}
        </button>
      )}

      {canBasic && tsfyUmatID && (
        <button
          onClick={() => setShowQrPusat(true)}
          className="cu-btn cu-primary"
        >
          {isZh() ? "中心QR碼" : "QR Pusat"}
        </button>
      )}
      
    </div>
    {showQrPusat && (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={() => setShowQrPusat(false)}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          width: "100%",
          maxWidth: 520,
          maxHeight: "90vh",
          overflowY: "auto",
          padding: 12,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <div style={{ fontWeight: 700 }}>
            {isZh() ? "中心 QR 碼" : "QR Pusat"}
          </div>
          <button onClick={() => setShowQrPusat(false)}>✕</button>
        </div>

        {/* Content */}
        <QrPusat umat={umat?.raw || umat} />

      </div>
    </div>
    )}    
    </>
  );
}
